import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

import { API } from "@/lib/apiBase";

export default function AdminStatsTab() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/stats`)
      .then((r) => setStats(r.data))
      .catch((err) => { console.error(err); toast.error("Failed to load stats"); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-white/40 font-body text-sm">Loading...</div>;
  if (!stats) return null;

  return (
    <div className="space-y-8" data-testid="admin-stats">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard label="Total Wines" value={stats.wines_total} />
        <StatCard label="Total Users" value={stats.users_total} />
        <StatCard label="Total Favorites" value={stats.favorites_total} />
      </div>
      <div>
        <p className="font-accent text-xs tracking-[0.3em] text-gold/60 mb-3">TOP FAVORITED</p>
        {stats.top_favorited.length === 0 ? (
          <div className="glass-card rounded-sm p-5 text-white/40 font-body text-sm">
            No favorites yet. Once users start saving wines, the most popular will appear here.
          </div>
        ) : (
          <TopFavoritedTable items={stats.top_favorited} />
        )}
      </div>
    </div>
  );
}

function StatCard({ label, value }) {
  return (
    <div className="glass-card rounded-sm p-6">
      <p className="font-body text-xs tracking-wider text-white/40 uppercase mb-2">{label}</p>
      <p className="font-display text-4xl text-white/90">{value}</p>
    </div>
  );
}

function TopFavoritedTable({ items }) {
  const cols = ["Wine", "Year", "Producer"];
  return (
    <div className="glass-card rounded-sm overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="border-white/5 hover:bg-transparent">
            {cols.map((c) => (
              <TableHead key={c} className="text-white/40 font-body text-xs uppercase tracking-wider">{c}</TableHead>
            ))}
            <TableHead className="text-white/40 font-body text-xs uppercase tracking-wider text-right">Favorites</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((w) => (
            <TableRow key={w.id} className="border-white/5 hover:bg-white/[0.02]">
              <TableCell className="text-white/85 font-body text-sm">{w.name}</TableCell>
              <TableCell className="text-white/60 font-body text-sm">{w.year}</TableCell>
              <TableCell className="text-white/60 font-body text-sm">{w.producer}</TableCell>
              <TableCell className="text-gold/80 font-body text-sm text-right">{w.favorites}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
